import script from "./form-language.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-language.vue?vue&type=script&setup=true&lang=ts"

import "./form-language.vue?vue&type=style&index=0&id=14630508&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14630508"]])

export default __exports__